import { render, staticRenderFns } from "./vue_jqxbuttons.vue?vue&type=template&id=2f56b005"
import script from "./vue_jqxbuttons.vue?vue&type=script&lang=js"
export * from "./vue_jqxbuttons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports